<template>
  <div>
    <div v-if="loading" class="text-center">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div>
            <div>
              <div class="avatar-profile">
                <img :src="usuario.avatar" alt="author-image" class="rounded-circle" width="100%" height="auto">
              </div>
              <div class="form-check mt-4 mb-4">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="agreement">
                <label class="form-check-label" for="flexCheckDefault">
                  subir avatar
                </label>
              </div>
              <div class="form-group mt-4 mb-4" v-if="agreement">
                <label>Avatar</label>
                <input
                  @change="on_file_change"
                  type="file"
                  class="form-control form-control-lg form-custom"
                  accept="image/png, image/jpeg"
                />
              </div>
              <div class="form-group mb-3">
                <label>Nombres</label>
                <input
                  v-model="usuario.nombres"
                  type="text"
                  placeholder="Nombres"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label>Apellidos</label>
                <input
                  v-model="usuario.apellidos"
                  type="text"
                  placeholder="Apellidos"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label>Celular/WhatsApp</label>
                <input
                  v-model="usuario.whatsapp"
                  type="text"
                  placeholder="Número de teléfono móvil"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label>Dirección</label>
                <input
                  v-model="usuario.direccion"
                  type="text"
                  placeholder="Dirección de residencia"
                  class="form-control"
                />
              </div>
              <div class="mt-2">
                <a
                  v-on:click="update_perfil"
                  href="javascript:void(0)"
                  class="btn mt-2 btn-primary w-100 btn-rounded"
                  >Actualizar</a
                >
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div>
          <div class="d-grid gap-2">
            <hr />
            <router-link
              to="/cambiar_clave"
              class="btn btn-outline-primary rounded-pill"
            >
              Cambiar mi contraseña
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Perfil",
  metaInfo: {
    title: "Perfil - Reddy App",
  },
  data() {
    return {
      loading: true,
      usuario: [],
      agreement: false,
      hay_archivo: false,
      file: null,
      loading_upload: false
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      const vm = this;
      axios
        .get(this.$base_url + "clientes/perfil", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.usuario = response.data.data;
            this.loading = false;
            console.log(this.usuario);
            var session = JSON.parse(localStorage.getItem("sess_reddy_app"));
            if(session.usuario.avatar != this.usuario.avatar){
              session.usuario.avatar = this.usuario.avatar;
              localStorage.setItem("sess_reddy_app",JSON.stringify(session));
            }
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    update_perfil: function () {
      if (
        this.usuario.nombres == null ||
        this.usuario.nombres.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu nombre",
        });
        return false;
      }
      if (
        this.usuario.apellidos == null ||
        this.usuario.apellidos.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu apellido",
        });
        return false;
      }
      if (
        this.usuario.whatsapp == null ||
        this.usuario.whatsapp.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu número de celular o Whatsapp",
        });
        return false;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let params = {
        usuario: this.usuario,
      };
      axios
        .post(this.$base_url + "clientes/update_perfil", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "<i class='fa fa-check-circle'></i> Excelente!",
              text: "Has actualizado tus datos de perfil.",
            });
            console.log(response);
            if(this.hay_archivo){
              vm.valida_upload();
            }
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
        
    },
    on_file_change: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file = files;
      this.hay_archivo = true;
      console.log(this.file, this.hay_archivo);
    },
    valida_upload: function () {
      this.hay_archivo = false;
      this.loading_upload = true;

      if(this.id_tipo_anexo==9 || this.id_tipo_anexo == 8){

        let vm = this;
        let file = this.file[0]; 
        let reader = new FileReader();
        
        reader.readAsDataURL(file);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            if(!vm.alert_img){

              vm.width = 900;
              vm.height = 450;

              if(img.width!=vm.width || img.height!=vm.height){
                vm.alert_img = true;
                vm.loading_upload = false;
                return false;
              }else{
                vm.upload();
              }
            }else{
              vm.upload();
            }
          
          }
          img.src = evt.target.result;
        }

        reader.onerror = evt => {
          console.error(evt);
        }
      } else{
        this.upload();
      }

      
    },
    upload:function(){
      var formData = new FormData();    
      formData.append("files", this.file[0]);
      formData.append("token", this.session.token);

      axios
        .post(this.$base_url + "upload/avatar", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.hay_archivo = false;
            this.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el avatar.",
            });
            this.loading_upload = false;
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            this.loading_upload = false;
          }
        })
        .catch((error) => {
          this.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          this.loading_upload = false;
        }); 
    }
  },
};
</script>
